const WORKY_SUPPORT_EMAIL: string = 'info@worky.pro';
const WORKY_SUPPORT_PHONE_DIGITS: string = '6474949090';
const WORKY_SUPPORT_PHONE_DISPLAY: string = '647-494-9090';

export { WORKY_SUPPORT_EMAIL, WORKY_SUPPORT_PHONE_DIGITS, WORKY_SUPPORT_PHONE_DISPLAY };
